import {
  createCustomFieldApplication as publicCreateCustomFieldApplication,
  deleteCustomFieldApplication as publicDeleteCustomFieldApplication,
  updateCustomFieldApplication as publicUpdateCustomFieldApplication,
  getCustomFieldApplication as publicGetCustomFieldApplication,
  getCustomFieldApplications as publicGetCustomFieldApplications,
  getMembersCustomFieldApplications as publicGetMembersCustomFieldApplications,
  getRolesCustomFieldApplications as publicGetRolesCustomFieldApplications,
} from './members-v1-custom-field-application-custom-field-applications.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const createCustomFieldApplication: MaybeContext<
  BuildRESTFunction<typeof publicCreateCustomFieldApplication> &
    typeof publicCreateCustomFieldApplication
> = /*#__PURE__*/ createRESTModule(publicCreateCustomFieldApplication);
export const deleteCustomFieldApplication: MaybeContext<
  BuildRESTFunction<typeof publicDeleteCustomFieldApplication> &
    typeof publicDeleteCustomFieldApplication
> = /*#__PURE__*/ createRESTModule(publicDeleteCustomFieldApplication);
export const updateCustomFieldApplication: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCustomFieldApplication> &
    typeof publicUpdateCustomFieldApplication
> = /*#__PURE__*/ createRESTModule(publicUpdateCustomFieldApplication);
export const getCustomFieldApplication: MaybeContext<
  BuildRESTFunction<typeof publicGetCustomFieldApplication> &
    typeof publicGetCustomFieldApplication
> = /*#__PURE__*/ createRESTModule(publicGetCustomFieldApplication);
export const getCustomFieldApplications: MaybeContext<
  BuildRESTFunction<typeof publicGetCustomFieldApplications> &
    typeof publicGetCustomFieldApplications
> = /*#__PURE__*/ createRESTModule(publicGetCustomFieldApplications);
export const getMembersCustomFieldApplications: MaybeContext<
  BuildRESTFunction<typeof publicGetMembersCustomFieldApplications> &
    typeof publicGetMembersCustomFieldApplications
> = /*#__PURE__*/ createRESTModule(publicGetMembersCustomFieldApplications);
export const getRolesCustomFieldApplications: MaybeContext<
  BuildRESTFunction<typeof publicGetRolesCustomFieldApplications> &
    typeof publicGetRolesCustomFieldApplications
> = /*#__PURE__*/ createRESTModule(publicGetRolesCustomFieldApplications);

export {
  Type,
  ExclusionType,
  Privacy,
  FieldTypeType,
  SocialTypeType,
  Origin,
  AppliesToEnumAppliesTo,
  Section,
  WebhookIdentityType,
} from './members-v1-custom-field-application-custom-field-applications.universal.js';
export {
  CustomFieldApplication,
  ApplicationsWrapper,
  AppliesTo,
  ExclusionsWrapper,
  Exclusion,
  CreateCustomFieldApplicationRequest,
  CreateCustomFieldApplicationResponse,
  DeleteCustomFieldApplicationRequest,
  DeleteCustomFieldApplicationResponse,
  UpdateCustomFieldApplicationRequest,
  UpdateCustomFieldApplicationResponse,
  GetCustomFieldApplicationRequest,
  GetCustomFieldApplicationResponse,
  GetCustomFieldApplicationsRequest,
  GetCustomFieldApplicationsResponse,
  GetMembersCustomFieldApplicationsRequest,
  GetMembersCustomFieldApplicationsResponse,
  MemberCustomFieldApplication,
  FieldApplication,
  CustomField,
  GetRolesCustomFieldApplicationsRequest,
  GetRolesCustomFieldApplicationsResponse,
  RoleCustomFieldApplication,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  UpdateCustomFieldApplication,
} from './members-v1-custom-field-application-custom-field-applications.universal.js';
export {
  TypeWithLiterals,
  ExclusionTypeWithLiterals,
  PrivacyWithLiterals,
  FieldTypeTypeWithLiterals,
  SocialTypeTypeWithLiterals,
  OriginWithLiterals,
  AppliesToEnumAppliesToWithLiterals,
  SectionWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './members-v1-custom-field-application-custom-field-applications.universal.js';
